import { render } from "./ListCustomerReturnReasons.vue?vue&type=template&id=a789bb98"
import script from "./ListCustomerReturnReasons.vue?vue&type=script&lang=js"
export * from "./ListCustomerReturnReasons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__